export type GovernanceVisibilitySettings = {
  showGovernance?: boolean;
};

/** Custom Policies activation requires an explicit organisation setting. */
export function isGovernanceVisible(
  settings: GovernanceVisibilitySettings | undefined,
): boolean {
  return settings?.showGovernance === true;
}
